import { Image } from 'expo-image';
import React from 'react';
import { Platform, View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import { isDesktop } from '@/core';
import { Button, Text } from '@/ui';
import { Eon } from '@/ui/icons/eon';

interface ForgotPasswordSentProps {
  onBack: () => void;
  onDone: () => void;
}

export default function ForgotPasswordSent({
  onBack,
  onDone,
}: ForgotPasswordSentProps) {
  const { styles } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <View style={styles.copyContainer}>
          {Platform.OS !== 'web' && (
            <Eon
              width="96"
              height="24"
              fill={UnistylesRuntime.themeName === 'dark' ? 'white' : 'black'}
            />
          )}

          <Image
            style={{ width: 55, height: 55, marginTop: 16 }}
            source={require('../../../../public/images/green-check-progress-bar.png')}
            contentFit="cover"
          />

          <View style={styles.textContainer}>
            <Text
              tx="forgotPasswordSent.subtitle"
              type="title1"
              style={styles.text}
            />

            <Text
              tx="forgotPasswordSent.body"
              type="bodyRegular"
              style={styles.text}
            />
          </View>
        </View>

        <View>
          <Image
            style={{
              width: 322,
              height: isDesktop() ? 450 : 400,
            }}
            source={
              UnistylesRuntime.themeName === 'dark'
                ? require('../../../../public/images/reset-password-notification-dark.png')
                : require('../../../../public/images/reset-password-notification-light.png')
            }
            contentFit="contain"
          />
        </View>
      </View>

      <View style={styles.buttonContainer}>
        <Button
          tx="forgotPasswordSent.goBack"
          type="primary"
          onPress={() => {
            onDone();
          }}
        />
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    backgroundColor: theme.colors.background_2,
    gap: 16,
    width: {
      md: 600,
    },
  },
  innerContainer: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  copyContainer: {
    alignItems: 'center',
    gap: 8,
    marginBottom: {
      xs: 8,
      md: 56,
    },
  },
  textContainer: {
    alignItems: 'center',
    gap: 16,
    width: 300,
  },
  text: {
    textAlign: 'center',
  },
  buttonContainer: {
    position: 'absolute',
    bottom: 50,
    left: 0,
    right: 0,
    alignItems: 'center',
    paddingLeft: 24,
    paddingRight: 24,
  },
}));
